module.exports = __webpack_public_path__ + "static/media/web3.ae490a19.jpg";